import type { CSSProperties } from 'react';

/** Staggers a reveal without a style cast in every component. */
export function delay(ms: number): CSSProperties {
  return { '--delay': `${ms}ms` } as CSSProperties;
}

export function ArrowOut() {
  return (
    <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <path d="M3 9L9 3M9 3H4M9 3v5" strokeLinecap="square" />
    </svg>
  );
}

export function DownloadIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="M12 3v12m0 0 5-5m-5 5-5-5M4 20h16" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/** Section heading plus the gradient rule that sat under it on the 2021 site. */
export function SectionHead({ title, id }: { title: string; id: string }) {
  return (
    <div data-reveal>
      <h2 className="section__title" id={id}>
        {title}
      </h2>
      <div className="block" />
    </div>
  );
}

const GLYPHS: Record<string, string> = {
  github:
    'M12 .5C5.7.5.6 5.6.6 11.9c0 5 3.3 9.3 7.8 10.8.6.1.8-.2.8-.6v-2c-3.2.7-3.9-1.5-3.9-1.5-.5-1.3-1.3-1.7-1.3-1.7-1-.7.1-.7.1-.7 1.1.1 1.7 1.1 1.7 1.1 1 1.8 2.7 1.3 3.4 1 .1-.7.4-1.3.7-1.6-2.6-.3-5.3-1.3-5.3-5.8 0-1.3.5-2.3 1.2-3.1-.1-.3-.5-1.5.1-3.1 0 0 1-.3 3.2 1.2a11 11 0 0 1 5.8 0c2.2-1.5 3.2-1.2 3.2-1.2.6 1.6.2 2.8.1 3.1.8.8 1.2 1.8 1.2 3.1 0 4.5-2.7 5.5-5.3 5.8.4.4.8 1.1.8 2.2v3.3c0 .4.2.7.8.6a11.4 11.4 0 0 0 7.8-10.8C23.4 5.6 18.3.5 12 .5Z',
  linkedin:
    'M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM2.4 9.75h5.16V21H2.4V9.75Zm7.7 0h4.95v1.54h.07c.69-1.24 2.38-2.05 4.06-2.05 4.34 0 5.14 2.66 5.14 6.12V21h-5.16v-4.9c0-1.17-.02-2.68-1.7-2.68-1.7 0-1.96 1.28-1.96 2.6V21H10.1V9.75Z',
  mail: 'M2 5.5A1.5 1.5 0 0 1 3.5 4h17A1.5 1.5 0 0 1 22 5.5v13a1.5 1.5 0 0 1-1.5 1.5h-17A1.5 1.5 0 0 1 2 18.5v-13Zm2.2.5 7.8 6 7.8-6H4.2ZM20 8.2l-7.4 5.7a1 1 0 0 1-1.2 0L4 8.2V18h16V8.2Z',
};

export function SocialIcon({ name }: { name: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d={GLYPHS[name] ?? GLYPHS.mail!} />
    </svg>
  );
}
